import { createVNode as _createVNode, createTextVNode as _createTextVNode, vShow as _vShow, withDirectives as _withDirectives, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"
import _imports_0 from '@/app/ui/assets/svg/info-square.svg'
import _imports_1 from '@/app/ui/assets/svg/close-white.svg'


const _hoisted_1 = {
  class: "flex flex-row items-center self-center py-2 px-4 rounded-lg gap-x-3 max-w-max my-3",
  style: {"background":"#5E9AF8"}
}
const _hoisted_2 = /*#__PURE__*/_createVNode("img", {
  src: _imports_0,
  class: "w-4",
  alt: "info-square"
}, null, -1)
const _hoisted_3 = /*#__PURE__*/_createVNode("p", { class: "text-white whitespace-normal text-12px" }, [
  /*#__PURE__*/_createTextVNode("Total berat volume dibagi 6.000 dari dimensi, tapi jika pilih "),
  /*#__PURE__*/_createVNode("strong", null, "kargo pesawat"),
  /*#__PURE__*/_createTextVNode(" akan dibagi 5.000 dari dimensi.")
], -1)
const _hoisted_4 = /*#__PURE__*/_createVNode("div", { class: "my-6" }, [
  /*#__PURE__*/_createVNode("hr")
], -1)
const _hoisted_5 = { class: "w-full flex justify-end" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ListCargoType = _resolveComponent("ListCargoType")!
  const _component_LpButton = _resolveComponent("LpButton")!
  const _component_Dialog = _resolveComponent("Dialog")!

  return (_openBlock(), _createBlock(_component_Dialog, {
    modelValue: _ctx.showModalCargoType,
    "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (_ctx.showModalCargoType = $event)),
    title: _ctx.$t(_ctx.titleDialog),
    persistent: "",
    onReset: _ctx.cancelModalCargoType
  }, {
    default: _withCtx(() => [
      _withDirectives(_createVNode("div", _hoisted_1, [
        _hoisted_2,
        _hoisted_3,
        _createVNode("img", {
          onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.showInfoDividerCargo = !_ctx.showInfoDividerCargo)),
          src: _imports_1,
          class: "w-3 cursor-pointer",
          alt: "close-white"
        })
      ], 512), [
        [_vShow, _ctx.showInfoDividerCargo]
      ]),
      _createVNode(_component_ListCargoType, { onOnChoose: _ctx.selectCargoType }, null, 8, ["onOnChoose"]),
      _hoisted_4,
      _createVNode("div", _hoisted_5, [
        _createVNode(_component_LpButton, {
          textColor: "white",
          title: _ctx.$t(_ctx.titleButtonDialog),
          fontWeight: "semibold",
          color: "red-lp-100",
          customClass: "py-3",
          onClick: _ctx.changeCargoType,
          disabled: _ctx.isDisableButton
        }, null, 8, ["title", "onClick", "disabled"])
      ])
    ]),
    _: 1
  }, 8, ["modelValue", "title", "onReset"]))
}